import { render, staticRenderFns } from "./selectionCategoryList.vue?vue&type=template&id=23eb7f9d&scoped=true"
import script from "./selectionCategoryList.vue?vue&type=script&lang=js"
export * from "./selectionCategoryList.vue?vue&type=script&lang=js"
import style0 from "./selectionCategoryList.vue?vue&type=style&index=0&id=23eb7f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb7f9d",
  null
  
)

export default component.exports